import { redirect } from 'react-router-dom';

// Compression
import { decompressSessionStorage } from '../utils/sessionStorage';

// Utils
import { getDefaultRouteForRole } from './utils';

// Types
import { Role } from '../types/auth';

export const LoaderIndexPage = () => {
  const userDataRaw = sessionStorage.getItem('user');
  if (userDataRaw) {
    const userData = JSON.parse(decompressSessionStorage(userDataRaw));
    if (userData?.user?.validated) {
      // Redirect to the appropriate route based on user's role
      const userRole = userData.user.rolActive as Role;
      const defaultRoute = getDefaultRouteForRole(userRole);
      return redirect(defaultRoute);
    }
  }
  return redirect('/login');
};
